import { Box, Button, HStack, Text } from '@chakra-ui/react'
import { useMemo } from 'react'
import type { ChildTicketTask } from '@/lib/services/childTicketService'
import { isTaskBreached } from './taskUtils'

type Props = {
  tasks: ChildTicketTask[]
  onViewTasks?: () => void
}

export default function TaskBottleneckBanner({ tasks, onViewTasks }: Props) {
  const breachedTask = useMemo(
    () => tasks.find((task) => isTaskBreached(task)),
    [tasks]
  )

  if (!breachedTask) {
    return null
  }

  return (
    <Box
      mb={4}
      p={3}
      borderRadius="md"
      border="1px solid"
      borderColor="red.200"
      bg="red.50"
    >
      <HStack justify="space-between" align="flex-start" flexWrap="wrap" gap={2}>
        <Box minW={0}>
          <Text fontSize="sm" fontWeight="700" color="red.700">
            Task SLA breached
          </Text>
          <Text fontSize="sm" color="red.800" mt={0.5}>
            {breachedTask.title || breachedTask.task_number} · {breachedTask.assignee_name ?? 'Unassigned'}
          </Text>
        </Box>
        {onViewTasks ? (
          <Button size="sm" colorScheme="red" variant="outline" onClick={onViewTasks}>
            Open task
          </Button>
        ) : null}
      </HStack>
    </Box>
  )
}
